"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const utils_1 = require("../../../lib/utils");
const button_1 = __importDefault(require("@kyruus/button"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_2 = require("./styles");
const variants = {
    initial: { y: '-20%', opacity: 0 },
    enter: { y: 0, opacity: 1 },
    exit: { y: '20%', opacity: 0 },
    open: {
        opacity: 1,
        height: 'auto',
        visibility: 'visible'
    },
    collapsed: {
        opacity: 0,
        height: 0,
        transitionEnd: {
            visibility: 'hidden'
        }
    }
};
const AnimatedList = react_1.default.forwardRef((props, ref) => (react_1.default.createElement(styles_1.List, Object.assign({}, props, { variants: variants, initial: "open", exit: "exit", ref: ref }))));
AnimatedList.displayName = 'AnimatedList';
const GroupedAppts = ({ headerDate, availableSlotData, onSelectAppt, provider, intl }) => {
    const SlotTile = ({ slot, intl }) => {
        return (react_1.default.createElement(styles_1.AppointmentSlotList, { className: "GroupedAppt", "data-testid": "GroupedAppts__Slot" },
            react_1.default.createElement(button_1.default, { mode: 'primary', onClick: () => onSelectAppt(slot), "aria-label": intl.formatMessage(messages_1.default.ariaProviderTimeSlotDescription, {
                    providerName: (0, utils_1.formatProviderName)(provider),
                    date: (0, utils_1.formatHeaderDate)(headerDate),
                    time: (0, utils_1.formatApptTime)(slot.start_datetime)
                }) }, (0, utils_1.formatApptTime)(slot.start_datetime))));
    };
    return (react_1.default.createElement(styles_2.StyledRowContainer, { "data-testid": "GroupedAppts" },
        react_1.default.createElement(styles_2.Header, { "data-testid": "GroupedAppts__header" },
            react_1.default.createElement("h5", null, (0, utils_1.formatHeaderDate)(headerDate))),
        react_1.default.createElement(AnimatedList, { key: headerDate, "data-testid": "GroupedAppts__Group__List" }, availableSlotData.map((slot) => (react_1.default.createElement(SlotTile, { slot: slot, intl: intl, key: slot.start_datetime }))))));
};
exports.default = (0, intl_1.injectIntl)(GroupedAppts);
//# sourceMappingURL=GroupedAppts.js.map